<template>
  <div>
    <notification />
    <div class="otp-section-wrapper content-wrapper">
      <progress-bar :currentStep="4"></progress-bar>
      <div class="header-request">
        <h3>{{ request.message }}</h3>
        <p v-if="isShowResend">
          Did not receive your OTP?
          <a class="link" @click.prevent="resendOtpInstruction">Resend</a>
        </p>
      </div>

      <div class="otp-form-wrapper">
        <form class="login-form" @submit.prevent="sendOtpInstruction">
          <div class="inputs-section">
            <!-- One-Time-Password (OTP) -->
            <div class="otp-input-block">
              <p>One-Time-Password (OTP)</p>
              <div class="input-wrapper">
                <input
                  v-model.trim="otp"
                  class="input-field"
                  type="password"
                  placeholder="Enter OTP..."
                  name="usrPassword"
                  autocomplete="one-time-code"
                />
              </div>
            </div>
          </div>

          <proceed-button :is-proceed-enable="!!otp" :is-loading="isLoading" />
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import NotificationEvent from '@/events/notificationEvents'
import ProgressBar from '@/components/ProgressBar'
import Notification from '@/components/Notification'
import ProceedButton from '@/components/buttons/ProceedButton'
import Constants from '@/constants'
import { blockBackNavigationMixin } from '@/mixins/blockBackNavigationMixin'

export default {
  name: 'Otp',
  components: {
    ProgressBar,
    Notification,
    ProceedButton,
  },
  mixins: [blockBackNavigationMixin],

  props: {
    request: {
      type: Object,
      default: () => {
        // Default value thats populated with the request being sent from backend
      },
    },
    instruction: {
      type: Object,
      default: () => {
        // Default value thats populated with the instruction being sent from backend
      },
    },
  },
  created() {
    NotificationEvent.setNotification(this.request.options)
  },
  data() {
    return {
      otp: '',
      allowedRoutes: [],
      isLoading: false,
    }
  },

  computed: {
    ...mapState('transaction', ['transaction']),
    ...mapGetters('merchantSettings', ['banksList']),
    transactionId() {
      return this.$route.query.transactionId
    },
    isShowResend() {
      return (
        this.transaction.acquirerCode !== Constants.acquirerCodes.Capitec &&
        this.transaction.acquirerCode !== Constants.acquirerCodes.Tyme &&
        this.transaction.acquirerCode !== Constants.acquirerCodes.Nedbank
      )
    },
  },
  methods: {
    sendOtpInstruction() {
      if (!this.otp) {
        return
      }

      this.isLoading = true
      this.$logInfo({
        transactionId: this.transactionId,
        message: Constants.logMessages.enteredOtp,
      })
      const instruction = {
        Otp: this.otp,
      }

      this.$emit('send-response', {
        messageId: this.request.messageId,
        instruction,
      })
    },

    resendOtpInstruction() {
      this.isLoading = true
      this.$logInfo({
        transactionId: this.transactionId,
        message: Constants.logMessages.otpResend,
      })
      const instruction = {
        ResendOtp: true,
      }

      this.$emit('send-response', {
        messageId: this.request.messageId,
        instruction,
      })
    },
  },
}
</script>

<style scoped lang="scss">
.otp-section-wrapper {
  padding: 0 20px 20px 20px;

  @media screen and (max-width: $mobile-resolution) {
    padding: 0;
  }
}

.header-request > a {
  & a {
    text-decoration: none;
  }
}

.otp-form-wrapper {
  width: 360px;
  margin: 0 auto;

  @media screen and (max-width: $mobile-resolution) {
    width: 100%;
    padding: 0 37px 60px 37px;
    margin: 0;
  }
}

.login-form {
  width: 100%;
}

.otp-input-block {
  display: flex;
  flex-direction: column;
  width: 360px;

  @media screen and (max-width: $mobile-resolution) {
    width: 100%;
  }

  & p {
    margin: 0 0 16px 0;
    font-weight: bold;
    font-size: 14px;
  }
}

.input-wrapper {
  display: flex;
  box-shadow: 0px 5px 10px rgba(212, 212, 212, 0.25);
  border-radius: 8px;

  & input:focus::placeholder {
    color: transparent;
  }
}

.icon-wrapper {
  display: grid;
  place-items: center;
  padding: 5px;
  border: 1px solid #f1f1f1;
  border-radius: 8px;
  z-index: 2;
}

.icon {
  height: 33px;
  width: 33px;
}
</style>
